import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

const STORAGE_KEY = 'tms_api_key';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly frontendKey = environment.frontendKey;

  constructor() {
  }

  /** Returns the user's key if set, otherwise the read-only frontend key */
  getApiKey(): string {
    return localStorage.getItem(STORAGE_KEY) || this.frontendKey;
  }

  /** Returns the read-only frontend key (for public search) */
  getFrontendKey(): string {
    return this.frontendKey;
  }

  /** True if the user has entered their own API key */
  isAuthenticated(): boolean {
    return !!localStorage.getItem(STORAGE_KEY);
  }

  setApiKey(key: string): void {
    localStorage.setItem(STORAGE_KEY, key);
  }

  clearApiKey(): void {
    localStorage.removeItem(STORAGE_KEY);
  }
}